import { getSite } from "@benkrejci/shared/dist/api/api"
import { useCachedFetchSingle } from "./useCachedFetch"

export const useSite = (doLoad: boolean = true) => {
  return useCachedFetchSingle('site', 'name', process.env.REACT_APP_SITE_NAME, {
    doLoad,
    load: getSite,
    getErrorMessage: () => 'Oh no! There was a problem loading that site 😭',
  })
}